var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgComplieLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M3.08504 4.06023L0.622379 6.50418C-0.20746 7.32816 -0.20746 8.6708 0.622379 9.49478L3.08369 11.9387L4.59029 10.4428L2.12898 7.99881L4.59029 5.55487L3.08369 4.0589L3.08504 4.06023Z",
    fill: "#00854D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4897 6.50421L8.05605 13.8854L5.59473 11.4414L4.08813 12.9374L6.54945 15.3814C6.96437 15.7933 7.50954 16 8.05605 16C8.60256 16 9.14639 15.7933 9.56265 15.3814L15.4897 9.49615C15.8925 9.09616 16.1141 8.5655 16.1141 8.00018C16.1141 7.43486 15.8925 6.9042 15.4897 6.50421Z",
    fill: "#00854D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M8.05727 2.11495L12.9812 7.00285L14.4865 5.50821L9.56253 0.618986C8.73135 -0.206329 7.38051 -0.206329 6.55067 0.618986L4.08936 3.06293L5.59595 4.5589L8.05727 2.11495Z",
    fill: "#00854D"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComplieLogo);
export default __webpack_public_path__ + "static/media/complie_logo.598c9fc766bc67ee6a3158d915fdec52.svg";
export { ForwardRef as ReactComponent };